import BannerBlock from './BannerBlock/BannerBlock'
import ProgramListBlock from './ProgramListBlock/ProgramListBlock'
import ProgramApplicationBlock from './ProgramApplicationBlock/ProgramApplicationBlock'

import style from './programspage.module.scss'

const ProgramsPage = () => {
    return (
        <div className={style.programspage}>
            <BannerBlock />
            <ProgramListBlock />
        </div>
    )
}

export default ProgramsPage